import agent, { prepareHeaders } from 'api/agent';
import {
    CatalogDishData,
    CatalogRestaurantDishModel,
    PagedList,
    UpdateRestaurantDataModel,
} from 'api/models';

const PATH = '/Catalog';

export const Catalog = {
    /**
     * Apply a restaurant-specific override to a catalog (menu, section, dish, or ingredient).
     * Supports actions such as DisableEnable, ChangeAmount, and ChangeWorkArea via the provided data model.
     * @param restaurantId The target restaurant ID.
     * @param catalogId The catalog ID to override within the restaurant.
     * @param data Override descriptor containing target entity id, payload, data type, and action.
     */
    RestaurantOverride(restaurantId: string, catalogId: string, data: UpdateRestaurantDataModel) {
        return agent.requests.put(
            `${PATH}/restaurant/${restaurantId}/catalog/${catalogId}`,
            data,
            prepareHeaders()
        );
    },
    GetAllDishes: (
        id: string,
        page: number = 0,
        limit: number = 100,
        orderBy: string = 'name',
        asc: boolean = true,
        enabledDishesOnly: boolean = false,
    ) => {
        const params = { page, limit, orderBy, asc, enabledDishesOnly };
        return agent.requests.get(`${PATH}/${id}`, { params }) as Promise<
            PagedList<CatalogDishData>
        >;
    },
    UpdateRestaurantCatalogDishData: (
        catalogId: string,
        restaurantId: string,
        dishId: string,
        model: CatalogRestaurantDishModel
    ) => {
        return agent.requests.post(
            `${PATH}/${catalogId}/restaurant/${restaurantId}/dish/${dishId}`,
            model
        ) as Promise<CatalogDishData>;
    },
};
